import React from "react";
import { User } from "~/common/Store/connectUserAndChat";
import PlusIneligibleModal from "~/common/components/PlusIneligibleModal";
import { PlusModalData } from "~/common/PlusSubscriptionModal/Models";
import PlusSubscriptionModalStore, { ModalTypes } from "~/common/PlusSubscriptionModal/PlusSubscriptionModalStore";
import loginModalStore from "~/common/LoginModalV2/loginModalStore";
interface PlusSignupLinkProps {
  className?: string;
  plusModalData: PlusModalData | undefined;
  user: User;
}
const PlusSignupLink = ({
  className = "",
  plusModalData,
  user
}: PlusSignupLinkProps) => {
  const hasValidAddresses = plusModalData?.validAddresses.length;
  const setPlusModalOpen = PlusSubscriptionModalStore.getState().setModalOpen;
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (!user.registered) {
      loginModalStore.openLogin({
        targetUrl: window.location.pathname,
        queryParams: "?showform=1"
      });
      return;
    }
    if (hasValidAddresses) setPlusModalOpen(ModalTypes.PLUS);else setPlusModalOpen(ModalTypes.INELIGIBLE);
  };
  if (user.hasWebPlus || !plusModalData) return null;
  const breakpointStyles = "xxxs:px-0";
  const interactionStyles = "focus:outline-none focus:ring-0 hover:text-blue-900";
  return <>
      <button className={`flex justify-start items-center bg-transparent border-0 font-medium text-blue-800 text-xs underline pt-0.5 shadow-[0px_1px_0px_0px_#FFFFFF] ${breakpointStyles} ${interactionStyles} ${className}`} data-testid="plus_memberPrice_cta" onClick={handleClick} type="button">
        Sign up for Plus
      </button>
      <PlusIneligibleModal data-sentry-element="PlusIneligibleModal" data-sentry-source-file="PlusSignupLink.tsx" />
    </>;
};
export default PlusSignupLink;